import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../../SYSTEM/Config.js'
import { sendPostRequest } from "./../../../APP/HELPERS/requests"

import InputMask from "react-input-mask";

/// REDUX ///
import * as ReduxActions from './../../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

function mapStateToProps(state) {
    return {
        USER: state.USER,
        CARD_MODAL: state.CARD_MODAL
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class Done extends Component {

    /// CONSTRUCTOR ///
    constructor(props) {
        super(props);
        this.state = {
            ORDER_ID: props.ORDER,
            NUMBER: props.NUMBER,
            EMAIL: '',
            NO_FORM: false,
            SECURITY: props.SECURITY
        }
    }

    componentDidMount() {

    }

    openLK() {
        this.props.openOrder(false);
        this.props.openLK(true);
    }

    recordEmail = (text) => {
        this.setState({ EMAIL: text.target.value });
    }

    renderLowerBlock() {
        return;
        return (
            <div>
                <div className="insta_coins">
                    <img src={ CONFIG.API_C_DOMAIN + '/imgs/coins.png' } />
                </div>
                <div className="insta_text">
                    За каждую вашу покупку в FOODSI.RU мы начисляем вам экобаллы на ваш <a onClick={ () => this.openLK() }>счет в личном кабинете</a>
                </div>
                <div className="insta_green">
                    <img src={ CONFIG.API_C_DOMAIN + '/imgs/insta_green.png' } />
                </div>
                <a target="_blank" href="https://www.instagram.com/foodsi.ru/" className="insta_link">
                    Подписывайтесь на наш Instagram,
                </a>
                <div className="insta_after">
                    следите за новостями, участвуйте в конкурсах и выигрывайте!
                </div>
            </div>
        );
    }

    sendToEmail = async () => {
        try {
            let TOKEN = 'UNREGISTERED';
            if (this.props.USER) {
                TOKEN = this.props.USER.TOKEN;
            }

            let SEND_DATA = {
                action: 'sendOrderLetter',
                id: this.state.ORDER_ID,
                email: this.state.EMAIL,
                apikey: TOKEN,
                security: this.state.SECURITY,

            };
            let data = await sendPostRequest(SEND_DATA, CONFIG.API_GATE);
            if (data !== false) {
                this.setState({ NO_FORM: true })
            }
        } catch (error) {
            console.log('BAD_ORDER_DATA');
        }
    }

    renderEmailForm() {
        let SHOW = false;
        if (!this.props.USER) {
            SHOW = true;
        } else {
            if (this.props.USER.EMAIL.length < 1) {
                SHOW = true;
            }
        }

        if (SHOW) {
            if (!this.state.NO_FORM) {
                return (
                    <div className="mail-form">
                        <div className="flex">
                            <div className="order_form_input_holder email_holder">
                                <input type="email" className="order-input email" placeholder="mail@mail.ru" value={ this.state.EMAIL } onChange={ (text) => this.recordEmail(text) } />
                            </div>
                            <div className="order_form_input_holder submit_holder">
                                <a className="orange-button" onClick={ () => this.sendToEmail() }>
                                    Отправить
                                </a>
                            </div>
                        </div>
                        <div className="form_letter_message">
                            Укажите email и мы пришлём информацию о вашем заказе
                        </div>
                    </div>
                );
            }
        }
    }

    goToLk = () => {
        this.props.openOrder(false);
        this.props.history.push('/personal');
    }

    render() {
        return (
            <div className="order_form_holder">
                <div className="modal_content">
                    <div className="order_finals_block flex_block">
                        <div className="done_head">
                            Спасибо! Ваш заказ принят
                        </div>
                        <div className="after_order_head">
                            Номер заказа<br /><span>{ this.state.NUMBER }</span>
                        </div>
                        <div className="done_message">
                            С деталями заказа<br />можно ознакомиться<br />в <span onClick={ () => this.goToLk() }>личном кабинете</span>
                        </div>
                        <div className="text-center">
                            <a className="orange-button slim" onClick={ () => this.props.openOrder(false) }>Понятно, спасибо!</a>
                        </div>
                        { this.renderEmailForm() }
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Done));